import { render, staticRenderFns } from "./InvestmentsOptionsForm.vue?vue&type=template&id=3d1b4b5e&scoped=true"
import script from "./InvestmentsOptionsForm.vue?vue&type=script&lang=js"
export * from "./InvestmentsOptionsForm.vue?vue&type=script&lang=js"
import style0 from "./InvestmentsOptionsForm.vue?vue&type=style&index=0&id=3d1b4b5e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1b4b5e",
  null
  
)

export default component.exports